export const LOAD_USER = 'load'
export const SAVE_USER = 'save'
export const TRASH_USER = 'trash'
export const UNTRASH_USER = 'untrash'
export const DELETE_USER = 'delete'
